import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { DollarSign } from 'lucide-react';

export function ReferralHero() {
  useLanguage();
  const handleContactClick = () => {
    window.open('https://api.whatsapp.com/send/?phone=557199407090&text=Ol%C3%A1%2C+quero+me+cadastrar+no+Programa+de+Parceiros+Host+VSL+e+come%C3%A7ar+a+indicar+clientes.&type=phone_number&app_absent=0', '_blank');
  };

  return (
    <div className="text-center space-y-6 py-8">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
        <DollarSign className="w-8 h-8 text-primary" />
      </div>
      
      <div className="space-y-4">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground">
          {translateInterfaceText("Ganhe de Forma Recorrente com o Programa de Parcerias Host VSL")}</h2>
        
        <p className="text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto">
          {translateInterfaceText("Indique a plataforma nº1 de VSLs do Brasil e receba")}{" "}<span className="font-semibold text-primary">{translateInterfaceText("20% de comissão recorrente")}</span> {" "}{translateInterfaceText("sobre os planos ativados pelos clientes que você indicar.")}</p>
      </div>
      
      <Button 
        size="lg" 
        className="mt-6"
        onClick={handleContactClick}
      >
        {translateInterfaceText("Quero Ser Parceiro Host VSL")}</Button>
    </div>
  );
}
